/* eslint-disable import/prefer-default-export */
import { GrowthBook } from '@growthbook/growthbook-react';
import { LocalStorageStickyBucketService } from '@growthbook/growthbook';

export const growthbook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: process.env.REACT_APP_GROWTHBOOK_KEY,
  enableDevMode: process.env.REACT_APP_TEMP_MEE_ENV === 'development',
  subscribeToChanges: true,
  trackingCallback: (experiment, result) => {
    console.log('Experiment Viewed', {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
  stickyBucketService: new LocalStorageStickyBucketService(),
});

export const setJobAttributes = async (job) => {
  await growthbook.setAttributes({
    ...growthbook.getAttributes(),
    job: {
      state: job?.state,
    },
  });
};

export const getShouldShowWhoCanSeeThisShift = () =>
  growthbook.isOn('should-show-who-can-see-this-shift');
export const shouldUseOfficeService = () => growthbook.isOn('use-office-service');
export const getShouldOfficeUnlimitedApplicationEnabled = () =>
  growthbook.isOn('unlimited-application-enabled-states');

export const getOffersToBestProfessionalsValue = () =>
  growthbook.getFeatureValue('TEMP-9245-offers-to-best-professionals', null);

// PostHog-backed flag getters (getShouldEnableBestInDental and friends) moved
// to ./posthog.js.

export const getShouldShowConsolidatedInvoices = () =>
  growthbook.isOn('TEMP-14775-enable-consolidated-invoices');
